import { render, staticRenderFns } from "./SchemaType.vue?vue&type=template&id=162feb7e&"
import script from "./SchemaType.vue?vue&type=script&lang=js&"
export * from "./SchemaType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports